export const capitalize = (str) => {
  if (!str || typeof str !== "string") return str || "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const titleCase = (str) => {
  if (!str || typeof str !== "string") return str || "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const DIACRITICS_RE = /[\u0300-\u036f]/g;
const DASH_CHARS_RE = /[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D\u00AD]/g;

export const normalizeForSearch = (value) => {
  const str = String(value ?? "");
  return str
    .normalize("NFKD")
    .replace(DIACRITICS_RE, "")
    .toLowerCase()
    .trim();
};

export const normalizeForMatch = (value) => {
  return normalizeForSearch(value)
    .replace(DASH_CHARS_RE, "-")
    .replace(/[^a-z0-9]+/g, "");
};
